export interface Options {
	label: string;
	value: string | number;
}

export const NON_OPTION_VALUE = "none-option";
